import { Component, EventEmitter, Output } from '@angular/core';

import { DialogService } from 'src/app/core/dialog.service';
import { StoreHeaderBulkCreationDialogComponent } from '../stores-header-bulk-creation-dialog/stores-header-bulk-creation-dialog.component';

@Component({
  selector: 'app-stores-header',
  templateUrl: './stores-header.component.html',
  styleUrls: ['./stores-header.component.scss'],
})
export class StoresHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialog_service: DialogService) {}

  onBulkStoresCreationClick() {
    this.dialog_service
      .openDialog(StoreHeaderBulkCreationDialogComponent)
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result && dialog_result.success) {
          this.refresh.emit();
        }
      });
  }
}
